<div class="modal-header" id="mileage-history-modal-title">
    <h3 class="modal-title" id="modal-title" translate="DASHBOARD_SIDEMENU_MILEAGE_HISTORY_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div class="row mb-3">
        <label class="col-2 col-form-label" for="fromDate" translate="DASHBOARD_SIDEMENU_MILEAGE_HISTORY_FROM"></label>
        <div class="col-3" *ngIf="fromDate">
            <pace-core-date-input
                id="fromDate"
                (valueChange)="filterHistory()"
                [(model)]="fromDate"
                [ariaLabel]="'DASHBOARD_SIDEMENU_MILEAGE_HISTORY_FROM' | translate"
            ></pace-core-date-input>
        </div>
        <label class="col-3 col-form-label" for="toDate" translate="DASHBOARD_SIDEMENU_MILEAGE_HISTORY_TO"></label>
        <div class="col-3" *ngIf="toDate">
            <pace-core-date-input
                id="toDate"
                (valueChange)="filterHistory()"
                [(model)]="toDate"
                [ariaLabel]="'DASHBOARD_SIDEMENU_MILEAGE_HISTORY_TO' | translate"
            ></pace-core-date-input>
        </div>
    </div>
    <div class="col-12">
        <table class="table text-center">
            <thead>
                <tr>
                    <th (click)="setOrderBy('recordedDate')">
                        <span translate="DASHBOARD_SIDEMENU_MILEAGE_HISTORY_DATE"></span>
                        <span
                            class="sortorder"
                            [hidden]="fieldName !== 'recordedDate'"
                            [ngClass]="{ reverse: reverse }"
                        ></span>
                    </th>
                    <th (click)="setOrderBy('startPlace')">
                        <span translate="DASHBOARD_SIDEMENU_MILEAGE_HISTORY_LOCATION"></span>
                        <span
                            class="sortorder"
                            [hidden]="fieldName !== 'startPlace'"
                            [ngClass]="{ reverse: reverse }"
                        ></span>
                    </th>
                    <th (click)="setOrderBy('endPlace')">
                        <span translate="DASHBOARD_SIDEMENU_MILEAGE_HISTORY_CUSTOMER"></span>
                        <span
                            class="sortorder"
                            [hidden]="fieldName !== 'endPlace'"
                            [ngClass]="{ reverse: reverse }"
                        ></span>
                    </th>
                    <th (click)="setOrderBy('distance')">
                        <span translate="DASHBOARD_SIDEMENU_MILEAGE_HISTORY_DISTANCE"></span>
                        <span
                            class="sortorder"
                            [hidden]="fieldName !== 'distance'"
                            [ngClass]="{ reverse: reverse }"
                        ></span>
                    </th>
                    <th (click)="setOrderBy('travelTime')">
                        <span translate="DASHBOARD_SIDEMENU_MILEAGE_HISTORY_TRAVEL_TIME"></span>
                        <span
                            class="sortorder"
                            [hidden]="fieldName !== 'travelTime'"
                            [ngClass]="{ reverse: reverse }"
                        ></span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let mileage of mileages | orderBy: fieldName : reverse">
                    <td>{{ mileage.formattedDisplayedDate }}</td>
                    <td>{{ mileage.startPlace }}</td>
                    <td>{{ mileage.endPlace }}</td>
                    <td>{{ mileage.distance }}</td>
                    <td>{{ mileage.travelTime }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <progressbar *ngIf="isLoading" [value]="100" type="default">Loading...</progressbar>
    <button
        [disabled]="true"
        class="btn btn-primary float-right"
        type="button"
        translate="DASHBOARD_SIDEMENU_MILEAGE_HISTORY_LABEL_BUTTON_REPORT"
    ></button>
</div>
